/// <amd-module name="TFS/Security/Common/Permissions/Contracts" />
import { SubjectPermission, PermissionTrace } from "TFS/Admin/Common/Contracts/OrganizationSettings";
import { PermissionChangeStatus } from "TFS/Admin/Common/Contracts/Permissions";

export interface ResourcePermission {
    id: string;
    permission: string;
    name: string;
    status: PermissionChangeStatus;
    subjectPermission: SubjectPermission;
    trace?: PermissionTrace;
}
